import { ComponentProps } from 'react';
import { CatToastGroup } from '@blocks-react/components/ToastGroup';
import { CatToast } from '@blocks-react/components/Toast';
import { CatIconSuccess } from '@blocks-react/components/Icons/Success';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';

type CatToastProps = ComponentProps<typeof CatToast>;
interface MyEquipmentToastProps {
  classname: string;
  onToastClose: () => void;
  toasts: [CatToastProps];
  delay: number;
}

export const MyEquipmentToast = ({
  classname,
  onToastClose,
  toasts,
  delay
}: MyEquipmentToastProps) => (
  <CatToastGroup horizontalPosition="center" verticalPosition="top">
    {toasts.map(({ key, variant, content }: CatToastProps) => {
      return (
        <div key={key}>
          <CatToast
            variant={variant}
            onBlToastClose={onToastClose}
            onBlToastCancel={onToastClose}
            delay={delay}
          >
            <div className={`${classname} d-flex`}>
              {variant === 'success' && (
                <CatIconSuccess className="me-3" slot="after" color="success" />
              )}
              {variant === 'error' && (
                <CatIconWarningCircle className="me-2" slot="after" color="error" />
              )}
              {content}
            </div>
          </CatToast>
        </div>
      );
    })}
  </CatToastGroup>
);
